import React from 'react';
import { useNavigate } from 'react-router';
import { Card, CardContent, CardHeader, Avatar, Typography, Divider, Button, Box, Chip, Stack } from '@mui/material';
import { OpenInNew, AdsClick } from '@mui/icons-material';
import UserAvatar from '../../UserAvatar';

const MessageCard = ({ message }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        const messageType = message.type.toLowerCase();

        if (messageType === 'email' && message.campaignId) {
            navigate(`/reports/email/${message.campaignId}`);
        }
        else if (messageType === 'page' && message.landingPageId) {
            navigate(`/reports/page/${message.landingPageId}`);
        }
        else if (messageType === 'survey' && message.surveyId) {
            navigate(`/editor/surveys/${message.surveyId}/results`);
        }
    };

    const buttonText = message.type === 'email'
        ? 'View Email Report'
        : message.type === 'page'
            ? 'View Landing Page Report'
            : 'View Survey Results';

    const typeText = message.type.charAt(0).toUpperCase() + message.type.substring(1);

    return (
        <Card sx={{ marginBottom: 2 }} className="team-message">
            <CardHeader
                avatar={message.userAvatar ? (
                    <UserAvatar image={message.userAvatar} />
                ) : (
                    <UserAvatar name={message.userName} />
                )}
                title={(
                    <Box
                        component="span"
                        className="teams-message-sender"
                        sx={{
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <Typography variant="h6">
                            {message.userName || 'Sender Name'}
                        </Typography>
                        <Typography variant="caption" sx={{ marginLeft: 2, mt: 0.7 }}>
                            {message?.created ? new Date(message.created).toLocaleString() : 'Time'}
                        </Typography>
                    </Box>
                )}
                subheader={(
                    <Stack direction="row" spacing={1} component="span">
                        <Chip
                            className="teams-message-opens"
                            label={<strong>Opens: {message.opens}</strong>}
                            icon={<OpenInNew fontSize="inherit" />}
                            variant="outlined"
                            size="small"
                            component="span"
                        />
                        {message.type !== 'survey' && (
                            <Chip
                                className="teams-message-opens"
                                label={<strong>{typeText} Clicks: {message.clicks ?? 0}</strong>}
                                icon={<AdsClick fontSize="inherit" />}
                                variant="outlined"
                                size="small"
                                component="span"
                            />
                        )}
                    </Stack>
                )}
                action={(
                    <Button
                        className="view-content"
                        sx={{
                            mt: 2,
                            mr: 1
                        }}
                        onClick={handleClick}
                        size="small"
                    >
                        {buttonText}
                    </Button>
                )}
            />
            <Divider />
            <CardContent>
                <Card className="teams-message-message" sx={{ borderRadius: 1, borderTop: '3px solid', borderColor: 'primary.main' }}>
                    <CardHeader
                        avatar={
                            message.image ? (
                                <Avatar sx={{ width: 45, height: 45 }} variant="square" src={message.image} />
                            ) : null
                        }
                        title={(
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                {message.title}
                            </Typography>
                        )}
                        subheader={(
                            <Typography variant="subtitle2">
                                {message.subtitle}
                            </Typography>
                        )}
                    />
                    <CardContent sx={{ pt: 0 }}>
                        <Typography variant="body1" sx={{ marginBottom: 2 }}>
                            {message.body}
                        </Typography>
                        <Button
                            variant="outlined"
                            href={
                                message.sharelink.includes('?')
                                    ? `${message.sharelink}&preview=true`
                                    : `${message.sharelink}?preview=true`
                            }
                            target="_blank"
                        >
                            View Content
                        </Button>
                    </CardContent>
                </Card>
            </CardContent>
        </Card>
    );
};

export default MessageCard;